import { HighlightConfig, SuperLatexContent, SuperLatexStepAction } from './super-latex.model';

export function applySuperLatexActions(content: SuperLatexContent, actions: SuperLatexStepAction[]): SuperLatexContent {
  const newContent = { ...content };

  // Ensure arrays are initialized if undefined
  newContent.latex_nodes = [...(newContent.latex_nodes || [])];
  newContent.annotations = [...(newContent.annotations || [])];
  newContent.connections = [...(newContent.connections || [])];
  newContent.highlighted_anchors = { ...(newContent.highlighted_anchors || {}) };

  for (const action of actions) {
    switch (action.type) {
      case 'add_nodes':
        if (action.position === 'start') {
          newContent.latex_nodes.unshift(...action.nodes);
        } else {
          newContent.latex_nodes.push(...action.nodes);
        }
        break;
      case 'insert_nodes': {
        const index = newContent.latex_nodes.findIndex((n) => (n.id ?? n.latex) === action.after_id);
        if (index !== -1) {
          newContent.latex_nodes.splice(index + 1, 0, ...action.nodes);
        }
        break;
      }
      case 'remove_nodes':
        newContent.latex_nodes = newContent.latex_nodes.filter((n) => !action.node_ids.includes(n.id ?? n.latex));
        break;
      case 'add_connections':
        newContent.connections.push(...action.connections);
        break;
      case 'remove_connections':
        newContent.connections = newContent.connections.filter((c) => !action.connection_ids.includes(c.id));
        break;
      case 'add_annotations':
        newContent.annotations.push(...action.annotations);
        break;
      case 'remove_annotations':
        newContent.annotations = newContent.annotations.filter((a) => !action.annotation_ids.includes(a.id));
        break;
      case 'add_highlights':
        newContent.highlighted_anchors = {
          ...newContent.highlighted_anchors,
          ...action.highlights,
        };
        break;
      case 'remove_highlights': {
        const newHighlights: Record<string, HighlightConfig> = { ...(newContent.highlighted_anchors || {}) };
        action.anchor_ids.forEach((id) => delete newHighlights[id]);
        newContent.highlighted_anchors = newHighlights;
        break;
      }
      case 'set_layout':
        newContent.layout = { ...newContent.layout, ...action.layout };
        break;
    }
  }

  return newContent;
}
